import React, { useEffect, useState } from "react";
import Styles from "./Styles.module.css";
import SelectDropdown from "../../../../Components/Dropdown/SelectDropdown";
import openImg from "../../../../Assets/images/store_open.png";
import closeImg from "../../../../Assets/images/store_close.png";
import storeBusinessOffImg from "../../../../Assets/images/store_business_off.png";
import CustomeCheckBox from "../../../../Components/CheckBox/checkBox";
import { FormField } from "../../../../Components/FormField";
import { ErrorMessage, Form, Formik } from "formik";
import SidebarField from "../../../../Components/SidebarField";
import Button from "../../../../Components/Button";
import Select from "react-select";
import selectDropdown from "../../../../custom/SelectDropdown";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import MenuApi from "../../../../App/api/menu.apis";
import { toast } from "react-toastify";
import { RegionMasterApi } from "../../../../App/api/RegionMaster";
import { Checkbox } from "primereact/checkbox";
import { FaLock, FaLockOpen, FaStore, FaStoreSlash } from "react-icons/fa";
import Toggle from "../../../../Components/Common/Toggle";
import { UsersApi } from "../../../../App/api/users.api";
import { getSelectOptions } from "../../../../utils/helpers/Functions.helper";
import DeliveryInfoApi from "../../../../App/api/deliveryinfo.api";

function RightCard({ sx, tabs, setTab,handlePagination,value,setPagination }) {
 
    //  const { value, fetchAllData } = useFetchAll(() =>
    //   UsersApi.getAllVendor(pagination ? pagination : {})
    //   );

    
  const { value: deliveryData,fetchAllData:getDeliveryType } = useFetchAll(()=>DeliveryInfoApi.getAllDeliveryInfo());
  const deliveryTypeOptions=getSelectOptions(deliveryData?.data,'name','name')

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isBusiness, setIsBusiness] = useState(true);
  const [isVisible, setIsVisible] = useState(true);
  const [cityOptions, setCityOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const { value: countryList } = useFetchAll(() => MenuApi.getAllCountry());
  const countryOptions = selectDropdown(countryList?.data, "_id", "name");
  const [selectedRegion, setSelectedRegion] = useState(null);

 const handleClearFilter = () => {
   setSelectedCountry(null);
   setCityOptions(null);
   setIsBusiness(true);
   setIsVisible(true);
   const clearPagination = {
     filter: {},
   };
   setPagination(clearPagination);
   // console.log("clearPagination:",pagination);
 };

  const handleCountryChange = async (selected, setFieldValue) => {
    setSelectedCountry(selected);
    setFieldValue("country", selected);
    setSelectedCity(null);
    setCityOptions([]);
    setRegionOptions([]);
    // console.log("selected country payload:", selected);

    if (selected?.value) {
      try {
        const res = await MenuApi.getAllCity(selected.value);
        setCityOptions(selectDropdown(res?.data?.data, "_id", "name"));
        setSelectedCity(selected.value);
        // console.log("city payload response :", res?.data?.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
        toast.error("Failed to load cities.");
      }
    }
  };
  



  const handleCityChange = async (selected, setFieldValue) => {
    setSelectedCity(selected);
    setFieldValue("city", selected);
    // console.log("selected city payload :", selected);

    try {
      const res = await RegionMasterApi.getAllRegionData();
      setRegionOptions(selectDropdown(res?.data?.data, "_id", "name"));
      setSelectedRegion(selected.value);
      // console.log("region payload response :", res?.data?.data);
    } catch (error) {
      // console.error("Error fetching regions:", error);
      toast.warning("No regions found for the selected city.", error);
    }
  };


  return (
    <Formik
      initialValues={{
        country: null,
        city: null,
        isBusiness: isBusiness,
        isVisible: isVisible,
      }}
      // validationSchema={validationSchema}
      // onSubmit={handleSubmit}
    >
      {({ setFieldValue, values, resetForm }) => (
        <Form>
          <div className="border p-6 w-[22vw] h-[92vh] bg-white">
            <h3 className="font-medium text-lg mb-2">Choose Location </h3>

            {/* {tabs.map((t,i)=>(<button key={i} onClick={()=>handleClick(t,i)} className={t.isActive?[`${Styles.active} ${Styles.navItem}`]:[`${Styles.navItem}`]}>{t.tab}</button>))}        */}

            <FormField label="Select Country" tooltip="Select a Country">
              <Select
                value={values.country}
                options={countryOptions}
                placeholder="Select Country"
                onChange={(selected) => {
                  handleCountryChange(selected, setFieldValue);
                  handlePagination("country", selected?.value);
                }}
              />
              <ErrorMessage name="country" component="p" className="error" />
            </FormField>

            <FormField label="Select City" tooltip="Select a City">
              <Select
                value={values.city}
                options={cityOptions}
                placeholder="Select City"
                onChange={(selected) =>{
                  handleCityChange(selected, setFieldValue)                      
                  handlePagination("city", selected?.value);

                }
                }
                isDisabled={!selectedCountry}
              />
              <ErrorMessage name="city" component="p" className="error" />
            </FormField>

            <FormField label="Store Type" tooltip="Select store type">
              <Select
                value={values.store_type}
                sx={{
                  width: "100%",
                  height: "2.5rem",
                  borderRadius: "3px",
                }}
                placeholder="select store type"
                options={deliveryTypeOptions||[]}
                onChange={(v) => {
                  console.log("delivery_business:", v.value);
                  handlePagination("delivery_business.name", v?.value);

                }}             
              />
              <ErrorMessage name="store_type" component="p" className="error" />
            </FormField>

           
            <div className="">
              <h3 className="font-medium text-lg mb-2">Store State </h3>

              <div className="flex items-center justify-between  my-4">
                <div className="flex items-center">
                  {!isVisible ? (
                    <FaStore size={"20px"} />
                  ) : (
                    <FaStoreSlash size={"20px"} />
                  )}
                  <label
                    htmlFor="is_active"
                    className=" ml-2 text-sm font-medium cursor-pointer"
                  >
                    Store Off
                  </label>
                </div>
                <input
                // className={styles.input}
                id="isVisible"
                name="isVisible"
                value={values.isVisible}
                onChange={() => {
                  console.log("checkbox value:", isVisible);
                  setIsVisible(!isVisible);
                  setFieldValue(!isVisible);
                  handlePagination("generalSettings.isVisible",!isVisible);

                }}
                type={"checkbox"}
              />
              </div>

              <div className="flex items-center justify-between my-4">
                <div className="flex items-center">
                  {!values.storeBusinessOff ? (
                    <FaLockOpen size={"20px"} />
                  ) : (
                    <FaLock size={"20px"} />
                  )}
                  <label
                    htmlFor="storeBusinessOff"
                    className=" ml-2 text-sm font-medium cursor-pointer"
                  >
                    Business Off
                  </label>
                </div>
                <input  
                // className={styles.input}
                id="isBusiness"
                name="isBusiness"
                value={values.isBusiness}
                onChange={() => {
                  console.log("checkbox value:",isBusiness);
                  setIsBusiness(!isBusiness);
                  setFieldValue(!isBusiness);
                  handlePagination("generalSettings.isBusiness",!isBusiness);

                }}
                type={"checkbox"}
              />
              </div>

            </div>
            <div className="flex justify-center">
              <Button type="Clear" text="Clear" onClick={handleClearFilter} />
                
              {/* <Button type="submit" text="Search" onClick={handleSubmit} /> */}
            </div>
            
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default RightCard;
